export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '287ab83', dateTime: 1765573947832 };